
function Download() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M30 24V28C30 29.103 29.103 30 28 30H4C2.897 30 2 29.103 2 28V24C2 23.448 2.448 23 3 23C3.552 23 4 23.448 4 24V28H28V24C28 23.448 28.448 23 29 23C29.552 23 30 23.448 30 24Z"
        fill="black"
      />
      <path
        d="M8.29325 16.707C7.90225 16.316 7.90225 15.684 8.29325 15.293C8.68425 14.902 9.31625 14.902 9.70725 15.293L15.0002 20.586V3C15.0002 2.448 15.4482 2 16.0002 2C16.5522 2 17.0002 2.448 17.0002 3V20.586L22.2932 15.293C22.6842 14.902 23.3163 14.902 23.7073 15.293C24.0983 15.684 24.0983 16.316 23.7073 16.707L16.7073 23.707C16.3113 24.104 15.6762 24.091 15.2922 23.707L8.29325 16.707Z"
        fill="black"
      />
    </svg>
  );
}

export default Download;
